import {
  getIsMockApplicantId,
  getIsRentalPortalApplicantIdentityMasked,
} from '../../../RentalPortalApplicant'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import { APPLICANT_PROFILE_ARCHIVE_BLOCKED_STAGES } from '../RentalPortalApplicantProfile.constants'
import { getApplicantProfileEmailsComposeTooltipKey } from '../RentalPortalApplicantProfileEmails'

import {
  APPLICANT_PROFILE_FOOTER_ACTION,
  APPLICANT_PROFILE_FOOTER_ACTION_ITEMS,
  APPLICANT_PROFILE_FOOTER_ACTION_PERMISSION_NAME,
  APPLICANT_PROFILE_FOOTER_ACTION_QA_NAME,
  APPLICANT_PROFILE_FOOTER_ACTION_TEXT_KEY,
  APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION,
  APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_ICON,
  APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_PERMISSION_NAME,
  APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_QA_NAME,
  APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_TEXT_KEY,
  APPLICANT_PROFILE_FOOTER_MASKED_ACTIONS,
  APPLICANT_PROFILE_FOOTER_UNAVAILABLE_TOOLTIP_KEY,
} from './RentalPortalApplicantProfileHeaderFooter.constants'

function getIsApplicantProfileFooterEmailAction(action) {
  return action === APPLICANT_PROFILE_FOOTER_ACTION.email
}

function getApplicantProfileFooterActionTooltipKey({ action, applicantData }) {
  if (getIsApplicantProfileFooterEmailAction(action)) {
    return getApplicantProfileEmailsComposeTooltipKey(applicantData)
  }

  return APPLICANT_PROFILE_FOOTER_MASKED_ACTIONS.includes(action) &&
    getIsRentalPortalApplicantIdentityMasked(applicantData)
    ? 'RentalPortal.ApplicantProfileActionMaskedTooltipKey'
    : APPLICANT_PROFILE_FOOTER_UNAVAILABLE_TOOLTIP_KEY[action]
}

function getIsApplicantProfileFooterActionPermitted({ action, applicantData }) {
  return applicantData?.permissions?.[
    APPLICANT_PROFILE_FOOTER_ACTION_PERMISSION_NAME[action]
  ]
}

function getIsApplicantProfileFooterArchiveAction(lifecycleAction) {
  return lifecycleAction === APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.archive
}

function getApplicantProfileFooterLifecycleActionItem({ applicantData, t }) {
  const lifecycleAction = applicantData?.archived
    ? APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.restore
    : APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.archive

  // TODO: archive backend applicants once the archive section reads the backend
  const hasPermission =
    getIsMockApplicantId(applicantData?.id) &&
    applicantData?.permissions?.[
      APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_PERMISSION_NAME[lifecycleAction]
    ]

  const isArchiveBlocked =
    getIsApplicantProfileFooterArchiveAction(lifecycleAction) &&
    APPLICANT_PROFILE_ARCHIVE_BLOCKED_STAGES.includes(applicantData?.stage)

  return hasPermission
    ? {
        Icon: APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_ICON[lifecycleAction],
        action: lifecycleAction,
        disabled: isArchiveBlocked,
        qaName:
          APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_QA_NAME[lifecycleAction],
        text: t(
          APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_TEXT_KEY[lifecycleAction]
        ),
        tooltipKey: isArchiveBlocked
          ? 'RentalPortal.ApplicantProfileArchiveBlockedTooltipKey'
          : null,
      }
    : null
}

export function getApplicantProfileFooterActions({ applicantData, t }) {
  const actions = APPLICANT_PROFILE_FOOTER_ACTION_ITEMS.filter(({ action }) =>
    getIsApplicantProfileFooterActionPermitted({ action, applicantData })
  ).map(({ Icon, action }) => {
    const tooltipKey = getApplicantProfileFooterActionTooltipKey({
      action,
      applicantData,
    })

    return {
      Icon,
      action,
      disabled: Boolean(tooltipKey),
      qaName: APPLICANT_PROFILE_FOOTER_ACTION_QA_NAME[action],
      text: t(APPLICANT_PROFILE_FOOTER_ACTION_TEXT_KEY[action]),
      tooltipKey,
    }
  })

  const lifecycleActionItem = getApplicantProfileFooterLifecycleActionItem({
    applicantData,
    t,
  })

  return lifecycleActionItem ? [...actions, lifecycleActionItem] : actions
}

export function getApplicantProfileFooterMoreOptions({ actions, t }) {
  return actions.map(({ action, disabled, text, tooltipKey }) => ({
    disabled,
    label: text,
    tooltipContent: tooltipKey ? t(tooltipKey) : null,
    value: action,
  }))
}

export function getApplicantProfileFooterBookViewingListing({
  applicantData,
  t,
}) {
  const label = getListingUnitLabel({ listing: applicantData, t })

  return label ? { label, value: applicantData.listing_id } : null
}

export function getIsApplicantProfileFooterOnlyMore({
  hiddenActions,
  visibleActions,
}) {
  return hiddenActions.length > 0 && visibleActions.length < 1
}
